/**
 * Reading / writing the enchantments stored on a Stack, plus tooltip lines.
 */

import type { Stack } from '../types';
import { E, enchDef } from './registry';

export { E };

/** Level of enchantment `id` on `s` (0 = none). */
export function enchLevel(s: Stack | null | undefined, id: number): number {
  if (!s || !s.ench) return 0;
  for (const e of s.ench) if (e.id === id) return e.lvl;
  return 0;
}

export const isEnchanted = (s: Stack): boolean => !!s.ench && s.ench.length > 0;

/** Set (or raise/lower) one enchantment; lvl <= 0 removes it. */
export function setEnch(s: Stack, id: number, lvl: number): void {
  const list = (s.ench ??= []);
  const i = list.findIndex((e) => e.id === id);
  if (lvl <= 0) { if (i >= 0) list.splice(i, 1); }
  else if (i >= 0) list[i].lvl = lvl;
  else list.push({ id, lvl });
  if (!list.length) delete s.ench;
}

const ROMAN = ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];
export const roman = (n: number): string => ROMAN[n] ?? String(n);

/** "Sharpness V" (single-level enchants such as Mending get no numeral, like vanilla). */
export function enchName(id: number, lvl: number): string {
  const d = enchDef(id);
  if (!d) return `Unknown ${id}`;
  return d.max === 1 && lvl === 1 ? d.name : `${d.name} ${roman(lvl)}`;
}

/** Gray tooltip lines under the item name, in stored order. */
export function enchTooltipLines(s: Stack): string[] {
  return (s.ench ?? []).map((e) => enchName(e.id, e.lvl));
}
